import React from "react";
import { Container, Card, ListGroup } from "react-bootstrap";
import Navbar from "../components/Navbar";
import Footer from "../components/Footer";

const MembershipPage = () => {
  return (
    <>
      <Navbar />
      <Container className="membership-container">
      <div className="container mx-auto px-4 py-12">
        <h2 className="text-2xl font-bold text-gray-800 text-center mb-6">
          Membership Eligibility and Conditions
        </h2>

        {/* Two-Column Card Layout */}
        <div className="grid md:grid-cols-2 gap-8">
          <div className="bg-white p-6 shadow-lg rounded-lg">
            <h3 className="text-green-600 font-bold text-xl mb-4">Eligibility Criteria:</h3>
            <ul className="text-gray-700 list-disc list-inside space-y-2">
              <li>Metropolitan hospital employee</li>
              <li>Ladnan hospital employee</li>
              <li>Former staff of affiliated organization</li>
              <li>Individuals referred by existing members</li>
              <li>Staff of Companies and any other formal organization admitted on checkoff arrangement</li>
            </ul>
          </div>

          <div className="bg-white p-6 shadow-lg rounded-lg">
            <h3 className="text-green-600 font-bold text-xl mb-4">Membership Conditions:</h3>
            <ul className="text-gray-700 list-disc list-inside space-y-2">
              <li>Fill in the application form and attach the following:</li>
              <li>Copy of national identity card</li>
              <li>Passport photo</li>
              <li>Pay Kshs 1,000 entrance fee</li>
              <li>Pay a minimum share capital of Ksh 10,000 (payable within the first 6 months)</li>
              <li>Contribute a minimum of Ksh. 2,000 every month toward the member deposit account</li>
            </ul>
          </div>
   </div></div></Container>
    
   

      <Footer />

     
    </>
  );
};

export default MembershipPage;
